class Modal extends HTMLElement {
  constructor() {
    super();

    this.triggers = document.querySelectorAll(".js-modal-trigger");
    this.modal = this.querySelector(".modal");
    this.close = this.querySelector(".modal__close");
    this.closeTriggers = this.querySelectorAll(".js-close");
    this.type = this.dataset.type;

    if (this.closeTriggers.length) {
      this.closeTriggers.forEach((button) => {
        button.addEventListener("click", () => this.closeModal());
      });
    }

    this.listeners();
  }

  listeners() {
    this.openModalEvent();
    this.closeModalEvent();
  }

  openModalEvent() {
    this.triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        const dataset = trigger.dataset;

        if (this.type === dataset.type) this.openModal(trigger);
      });
    });
  }

  closeModalEvent() {
    this.close.addEventListener("click", () => this.closeModal());

    this.addEventListener("click", (event) => {
      if (event.target === this.modal) this.closeModal();
    });

    // Close on Escape key
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && this.modal.classList.contains("modal--active")) {
        this.closeModal();
      }
    });
  }

  openModal() {
    this.modal.classList.add("modal--active");

    document.body.classList.add("overflow-hidden");
  }

  closeModal() {
    this.modal.classList.remove("modal--active");

    document.body.classList.remove("overflow-hidden");
  }
}

customElements.define("modal-component", Modal);
